/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable react/destructuring-assignment */
import * as React from 'react';
import { Grid, Hidden } from '@material-ui/core';
import { InfoPerksContext, } from '../../../../../../contexts';
import { AlertMessage, LeftIconFreerental, LeftIconExpired, LeftIconUnlockedChoosePerk, LeftPerkInProgress, MobileLeftCircleInprogress, MobileLeftIconExpired, MobileLeftIconUnlockedChoosePerk, SpendLevelExpired, SpendLevelActiveStatus, SpendLevelUnclaimed, SpendLevelRedeemedStatus, IconRedeemed, RightIconActive, SpendLevelCurrentTier, SpendLevelFutureTier, RightIconCurrentTier, RightIconDefault, RightIconRedeemed, MobileRightIconbadgUnlocked, RightIconExpired, RightIconInProgress, MobileIconFreerental, RightIconExpiringAlert, MobileRightIconExpiringAlert, SpendLevelUnclaimedExpired, LeftIconUnclaimedExpired, RightIconunclaimedExpired, MobileLeftIconUnclaimedExpired, MobileGenericCircleInprogress, } from '../../../commons/PerkProgressSpendCommons';
import { showTrackerDotTooltip, hideTrackerDotTooltip, getPLCCAccrualData, } from '../../../commons/TrackerUtils';
var circleRef = React.createRef();
var progressIconCircle1 = "rotate(".concat(68, "deg)");
export var SpendLevel = function (props) {
    var data = props.data, stateData = props.stateData, controlToggle = props.controlToggle, detailsPlcc = props.detailsPlcc, plccSwitch = props.plccSwitch, showUnlockAnimateTier = props.showUnlockAnimateTier, isLoading = props.isLoading;
    var item = (data || {}).item;
    var tierPerks = (item || []).tierPerks;
    var perkStatusData = tierPerks && tierPerks[0] && tierPerks[0].perkStatus;
    var perkStatusActive = tierPerks[0].perkStatus === 'ACTIVE' ||
        tierPerks[0].perkStatus === 'INACTIVE';
    var perkStatusRedeemed = tierPerks[0].perkStatus === 'REDEEMED';
    var unclaimedData = tierPerks[0].perkStatus === 'UNCLAIMED';
    var expiredPerk = tierPerks[0].perkStatus === 'EXPIRED';
    var activationTime = tierPerks[0].activationTime;
    var spend;
    if (perkStatusData && expiredPerk && activationTime) {
        spend = React.createElement(SpendLevelExpired, { data: data });
    }
    else if (perkStatusData && expiredPerk && !activationTime) {
        spend = React.createElement(SpendLevelUnclaimedExpired, { data: data });
    }
    else if (perkStatusData && unclaimedData) {
        spend = (React.createElement(SpendLevelUnclaimed, { data: data, stateData: stateData, controlToggle: controlToggle, detailsPlcc: detailsPlcc, plccSwitch: plccSwitch, showUnlockAnimateTier: showUnlockAnimateTier, isLoading: isLoading }));
    }
    else if (perkStatusActive) {
        spend = React.createElement(SpendLevelActiveStatus, { data: data });
    }
    else if (perkStatusData && perkStatusRedeemed) {
        spend = React.createElement(SpendLevelRedeemedStatus, { data: data });
    }
    else if (stateData.nextTierId === item.tierId) {
        spend = (React.createElement(SpendLevelFutureTier, { data: data, stateData: stateData, controlToggle: controlToggle, detailsPlcc: detailsPlcc, plccSwitch: plccSwitch }));
    }
    else if (stateData.currentTierId === item.tierId) {
        spend = (React.createElement(SpendLevelCurrentTier, { data: data, stateData: stateData, controlToggle: controlToggle, detailsPlcc: detailsPlcc, plccSwitch: plccSwitch, toggleAnimation: false }));
    }
    else {
        spend = null;
    }
    return React.createElement(React.Fragment, null, spend);
};
export var RenderLeftIcon = function (props) {
    var data = props.data, stateData = props.stateData, choosePerk = props.choosePerk;
    var item = (data || {}).item;
    var tierPerks = (item || []).tierPerks;
    var dayLeft = tierPerks[0].daysLeft <= 14 && tierPerks[0].daysLeft > 0;
    var statusUnclaimed = tierPerks[0].perkStatus === 'UNCLAIMED';
    var statusActive = tierPerks[0].perkStatus === 'ACTIVE' ||
        tierPerks[0].perkStatus === 'INACTIVE';
    var redeemed = tierPerks[0].perkStatus === 'REDEEMED';
    var expiredPerk = tierPerks[0].perkStatus === 'EXPIRED';
    var activationTime = tierPerks[0].activationTime;
    var inProgressCurrent = stateData.currentTierId === item.tierId;
    var leftDetails;
    if (activationTime && expiredPerk) {
        leftDetails = React.createElement(LeftIconExpired, { data: data });
    }
    else if (expiredPerk && !activationTime) {
        leftDetails = React.createElement(LeftIconUnclaimedExpired, { data: data });
    }
    else if (redeemed) {
        leftDetails = React.createElement(IconRedeemed, { data: data });
    }
    else if (statusUnclaimed && dayLeft) {
        leftDetails = React.createElement(AlertMessage, { data: data });
    }
    else if (inProgressCurrent) {
        leftDetails = React.createElement(LeftPerkInProgress, { data: data });
    }
    else if (statusUnclaimed) {
        if (choosePerk()) {
            leftDetails = React.createElement(LeftIconUnlockedChoosePerk, { data: data });
        }
        else {
            leftDetails = React.createElement(LeftIconFreerental, { data: data });
        }
    }
    else if (statusActive) {
        leftDetails = React.createElement(LeftIconFreerental, { data: data });
    }
    else {
        leftDetails = React.createElement(LeftPerkInProgress, { data: data });
    }
    return leftDetails;
};
export var RenderRightIcon = function (props) {
    var data = props.data, stateData = props.stateData, filterData = props.filterData, currentDataIndex = props.currentDataIndex;
    var perksInfo = (React.useContext(InfoPerksContext) || {}).perksInfo;
    var finalTierPerkAchieved = getPLCCAccrualData({
        accrualData: perksInfo === null || perksInfo === void 0 ? void 0 : perksInfo.accrualData,
    }).finalTierPerkAchieved;
    var item = (data || {}).item;
    var tierPerks = (item || []).tierPerks;
    var daysLeft = tierPerks[0].daysLeft <= 14 && tierPerks[0].daysLeft > 0;
    var statusActive = tierPerks[0].perkStatus === 'ACTIVE' ||
        tierPerks[0].perkStatus === 'INACTIVE';
    var statusRedeemed = tierPerks[0].perkStatus === 'REDEEMED';
    var statusUnclaimed = tierPerks[0].perkStatus === 'UNCLAIMED';
    var expiredPerk = tierPerks[0].perkStatus === 'EXPIRED';
    var inProgressCurrent = stateData.currentTierId === item.tierId;
    var activationTime = tierPerks[0].activationTime;
    var rightIcon;
    if (expiredPerk && activationTime) {
        rightIcon = (React.createElement(RightIconExpired, { data: data, filterData: filterData, currentDataIndex: currentDataIndex }));
    }
    else if (expiredPerk && !activationTime) {
        rightIcon = (React.createElement(RightIconunclaimedExpired, { data: data, filterData: filterData, currentDataIndex: currentDataIndex }));
    }
    else if (inProgressCurrent && !finalTierPerkAchieved) {
        rightIcon = (React.createElement(RightIconInProgress, { filterData: filterData, currentDataIndex: currentDataIndex }));
    }
    else if (statusUnclaimed && daysLeft) {
        rightIcon = (React.createElement(RightIconExpiringAlert, { data: data, filterData: filterData, currentDataIndex: currentDataIndex }));
    }
    else if (statusUnclaimed) {
        rightIcon = (React.createElement(RightIconDefault, { filterData: filterData, currentDataIndex: currentDataIndex }));
    }
    else if (statusRedeemed) {
        rightIcon = (React.createElement(RightIconRedeemed, { filterData: filterData, currentDataIndex: currentDataIndex }));
    }
    else if (statusActive) {
        rightIcon = (React.createElement(RightIconActive, { filterData: filterData, currentDataIndex: currentDataIndex, data: data }));
    }
    else {
        rightIcon = (React.createElement(RightIconCurrentTier, { filterData: filterData, currentDataIndex: currentDataIndex }));
    }
    return rightIcon;
};
export var RenderLeftMobileIcon = function (props) {
    var data = props.data, stateData = props.stateData, choosePerk = props.choosePerk;
    var item = (data || {}).item;
    var tierPerks = (item || []).tierPerks;
    var mobileYearSpendMax = stateData.currentYearSpend >= item.maxThreshold;
    var daysLeft = tierPerks[0].daysLeft <= 14 && tierPerks[0].daysLeft > 0;
    var spendLessMin = stateData.currentYearSpend < item.minThreshold;
    var statusUnclaim = tierPerks[0].perkStatus === 'UNCLAIMED';
    var expired = tierPerks[0].perkStatus === 'EXPIRED';
    var statusRedeemed = tierPerks[0].perkStatus === 'REDEEMED';
    var statusActive = tierPerks[0].perkStatus === 'ACTIVE' ||
        tierPerks[0].perkStatus === 'INACTIVE';
    var unclaimedExpired = tierPerks[0].earned;
    var inProgressCurrent = stateData.currentTierId === item.tierId;
    var leftIcon;
    if (statusUnclaim && daysLeft) {
        leftIcon = React.createElement(MobileLeftIconUnlockedChoosePerk, null);
    }
    else if (inProgressCurrent) {
        leftIcon = React.createElement(MobileGenericCircleInprogress, null);
    }
    else if (statusUnclaim) {
        if (choosePerk()) {
            leftIcon = React.createElement(MobileRightIconbadgUnlocked, null);
        }
        else {
            leftIcon = React.createElement(MobileIconFreerental, null);
        }
    }
    else if (spendLessMin) {
        leftIcon = React.createElement(MobileLeftCircleInprogress, null);
    }
    else if (mobileYearSpendMax && expired) {
        leftIcon = React.createElement(MobileLeftIconExpired, { data: data });
    }
    else if (statusUnclaim && !unclaimedExpired) {
        leftIcon = React.createElement(MobileLeftIconUnclaimedExpired, null);
    }
    else if (mobileYearSpendMax && statusRedeemed) {
        leftIcon = React.createElement(MobileIconFreerental, null);
    }
    else if (mobileYearSpendMax && statusActive) {
        leftIcon = React.createElement(MobileIconFreerental, null);
    }
    else {
        leftIcon = React.createElement(MobileLeftCircleInprogress, null);
    }
    return leftIcon;
};
export var RenderRightMobileIcon = function (props) {
    var data = props.data, stateData = props.stateData;
    var item = (data || {}).item;
    var tierPerks = (item || []).tierPerks;
    var rightIcon;
    var mobileYearSpendMax = stateData.currentYearSpend >= item.maxThreshold;
    var spendLessMin = stateData.currentYearSpend < item.minThreshold;
    var daysLeft = tierPerks[0].daysLeft <= 14 && tierPerks[0].daysLeft > 0;
    var spendLessMax = stateData.currentYearSpend < item.maxThreshold;
    var statusUnclaimed = tierPerks[0].perkStatus === 'UNCLAIMED';
    var expired = tierPerks[0].perkStatus === 'EXPIRED';
    var statusActive = tierPerks[0].perkStatus === 'ACTIVE' ||
        tierPerks[0].perkStatus === 'INACTIVE';
    var statusRedeemed = tierPerks[0].perkStatus === 'REDEEMED';
    var unclaimedExpired = tierPerks[0].earned;
    var inProgressCurrent = stateData.currentTierId === item.tierId;
    if (mobileYearSpendMax && statusUnclaimed && daysLeft) {
        rightIcon = React.createElement(MobileRightIconExpiringAlert, null);
    }
    else if (statusUnclaimed) {
        rightIcon = React.createElement(MobileRightIconbadgUnlocked, null);
    }
    else if (expired) {
        rightIcon = React.createElement(MobileLeftIconExpired, { data: data });
    }
    else if (inProgressCurrent) {
        rightIcon = React.createElement(MobileGenericCircleInprogress, null);
    }
    else if (statusUnclaimed && !unclaimedExpired) {
        rightIcon = React.createElement(MobileLeftIconUnclaimedExpired, null);
    }
    else if (spendLessMin) {
        rightIcon = React.createElement(MobileLeftCircleInprogress, null);
    }
    else if (spendLessMax) {
        rightIcon = React.createElement(MobileLeftCircleInprogress, null);
    }
    else if (mobileYearSpendMax && (statusActive || statusRedeemed)) {
        rightIcon = React.createElement(MobileIconFreerental, null);
    }
    else {
        rightIcon = React.createElement(MobileRightIconbadgUnlocked, null);
    }
    return rightIcon;
};
export var ToolTipCircle1 = function () { return (React.createElement("circle", { className: "circle9_progress_Circle", cx: "9", cy: "25", r: "3" })); };
export var ToolTipCircleEarned = function (props) {
    var toolTipCircleEarnedClass = 'circle10_symbol_circle';
    var toolTipCirclePulseClass = toolTipCircleEarnedClass;
    var isLoading = props.isLoading, showUnlockAnimateTier = props.showUnlockAnimateTier;
    var iconTransform = isLoading || isLoading === undefined
        ? "rotate(".concat(148, "deg)")
        : "rotate(".concat(428, "deg)");
    if (!isLoading && showUnlockAnimateTier) {
        toolTipCircleEarnedClass = toolTipCircleEarnedClass.concat(' circle-startpoint circle-animate');
        toolTipCirclePulseClass = toolTipCircleEarnedClass.concat(' circle-earned-pulse');
    }
    return (React.createElement(React.Fragment, null,
        React.createElement("circle", { className: toolTipCircleEarnedClass, cx: "9", cy: "25", r: "3", style: { transform: iconTransform } }),
        React.createElement("circle", { className: toolTipCirclePulseClass, cx: "9", cy: "25", r: "3", style: { transform: iconTransform } })));
};
var CurrentSymbol = function (props) {
    var data = props.data, stateData = props.stateData, isLoading = props.isLoading, showUnlockAnimateTier = props.showUnlockAnimateTier;
    var item = (data || {}).item;
    var unclaimedStatus = (item === null || item === void 0 ? void 0 : item.tierPerks[0].perkStatus) === 'UNCLAIMED';
    var spendMin = stateData.currentYearSpend > (item === null || item === void 0 ? void 0 : item.minThreshold);
    var spendMax = stateData.currentYearSpend >= (item === null || item === void 0 ? void 0 : item.maxThreshold);
    var activeStatus = (item === null || item === void 0 ? void 0 : item.tierPerks[0].perkStatus) === 'ACTIVE';
    var symbolStatus = (item === null || item === void 0 ? void 0 : item.tierPerks[0].perkStatus) === 'EXPIRED' ||
        (item === null || item === void 0 ? void 0 : item.tierPerks[0].perkStatus) === 'REDEEMED';
    var isCurrentTier = item === null || item === void 0 ? void 0 : item.currentTier;
    var symbol;
    if (unclaimedStatus) {
        symbol = (React.createElement(ToolTipCircleEarned, { isLoading: isLoading, showUnlockAnimateTier: showUnlockAnimateTier }));
    }
    else if (spendMax || (activeStatus && symbolStatus)) {
        symbol = React.createElement(ToolTipCircle1, null);
    }
    else if (spendMin && isCurrentTier) {
        symbol = (React.createElement(ToolTipCurrentCircle, { stateData: stateData, isLoading: isLoading }));
    }
    else if (isCurrentTier) {
        symbol = React.createElement(ToolTipCurrentCircle, { stateData: stateData, isLoading: true });
    }
    else {
        symbol = null;
    }
    return React.createElement(React.Fragment, null, symbol);
};
var ToolTipCurrentCircle = function (props) {
    var stateData = props.stateData, isLoading = props.isLoading;
    return (React.createElement(React.Fragment, null,
        React.createElement(Hidden, { smDown: true },
            React.createElement(Hidden, { lgDown: true },
                React.createElement(ToolTipProgressCircle, { stateData: stateData, isLoading: isLoading })),
            React.createElement(Hidden, { xlUp: true },
                React.createElement(ToolTipMobileCircle, { isLoading: isLoading }))),
        React.createElement(Hidden, { mdUp: true },
            React.createElement(ToolTipMobileCircle, { isLoading: isLoading }))));
};
var ToolTipMobileCircle = function (props) {
    var isLoading = props.isLoading;
    var iconTransform = isLoading ? "rotate(".concat(148, "deg)") : progressIconCircle1;
    return (React.createElement("svg", { viewBox: "0 0 100 100", preserveAspectRatio: "xMidYMin slice" },
        React.createElement("circle", { id: "ToolTipProgressCircle-trigger", className: isLoading
                ? 'progressCircleTool'
                : 'progressCircleTool progressCircleAnimate', cx: "9", cy: "25", r: "3", ref: circleRef, fill: "steelblue", style: { transform: iconTransform }, onMouseEnter: showTrackerDotTooltip, onMouseDown: showTrackerDotTooltip, onTouchStart: showTrackerDotTooltip, onMouseOut: hideTrackerDotTooltip, onBlur: hideTrackerDotTooltip })));
};
var ToolTipProgressCircle = function (props) {
    var isLoading = props.isLoading;
    var iconTransform = isLoading ? "rotate(".concat(148, "deg)") : progressIconCircle1;
    return (React.createElement("svg", { viewBox: "0 0 100 100", preserveAspectRatio: "xMidYMin slice" },
        React.createElement("circle", { id: "ToolTipProgressCircle-trigger", className: isLoading
                ? 'progressCircleTool'
                : 'progressCircleTool progressCircleAnimate', cx: "9", cy: "25", r: "3", ref: circleRef, fill: "steelblue", style: { transform: iconTransform }, onMouseEnter: showTrackerDotTooltip, onMouseDown: showTrackerDotTooltip, onTouchStart: showTrackerDotTooltip, onMouseOut: hideTrackerDotTooltip, onBlur: hideTrackerDotTooltip })));
};
export var RenderlSvgMobileCircle = function (props) {
    var data = props.data, PerkInfo = props.PerkInfo, isLoading = props.isLoading, showUnlockAnimateTier = props.showUnlockAnimateTier, stateData = props.stateData;
    return (React.createElement("svg", { viewBox: "0 0 100 100", className: "gauge_perk_progress1", preserveAspectRatio: "xMidYMin slice" },
        React.createElement("circle", { className: "circle1_perk_progress", cx: "50", cy: "50", r: "48" }),
        React.createElement("defs", null,
            React.createElement("linearGradient", { id: "red", x1: "0%", y1: "0%", x2: "100%", y2: "0%" },
                React.createElement("stop", { offset: "100%", stopColor: "#f96302", stopOpacity: "0.9" }))),
        React.createElement(ActiveCircleProgress, { data: data, PerkInfo: PerkInfo, isLoading: isLoading, showUnlockAnimateTier: showUnlockAnimateTier }),
        React.createElement("circle", { className: "circle7_perl_progress", cx: "9", cy: "25", r: "3" }),
        React.createElement(CurrentSymbol, { stateData: stateData, data: data, isLoading: isLoading, showUnlockAnimateTier: showUnlockAnimateTier })));
};
var ActiveCircleProgress = React.memo(function (props) {
    var _a, _b, _c, _d;
    var isLoading = props.isLoading, showUnlockAnimateTier = props.showUnlockAnimateTier, data = props.data;
    var perksInfo = React.useContext(InfoPerksContext).perksInfo;
    var item = (data || {}).item;
    var percentage = item === null || item === void 0 ? void 0 : item.progressPercentage;
    var degree = 2.8 * percentage - 214;
    progressIconCircle1 = "rotate(".concat(degree, "deg)");
    var statusActive = ((_b = (_a = item === null || item === void 0 ? void 0 : item.tierPerks) === null || _a === void 0 ? void 0 : _a[0]) === null || _b === void 0 ? void 0 : _b.perkStatus) === 'ACTIVE';
    var statusExpired = ((_d = (_c = item === null || item === void 0 ? void 0 : item.tierPerks) === null || _c === void 0 ? void 0 : _c[0]) === null || _d === void 0 ? void 0 : _d.perkStatus) === 'EXPIRED';
    var isCurrentTier = item === null || item === void 0 ? void 0 : item.currentTier;
    var isEarned = item === null || item === void 0 ? void 0 : item.earned;
    var activeCircleClass = 'circle2_perk_progress ';
    var percentageAt100 = percentage === 100;
    var isFutureTier = !(isCurrentTier ||
        isEarned ||
        perksInfo.currentYearSpend > (item === null || item === void 0 ? void 0 : item.maxThreshold));
    if ((!statusActive && !statusExpired && showUnlockAnimateTier) ||
        (isCurrentTier && !percentageAt100)) {
        activeCircleClass = activeCircleClass.concat('circle-animate');
    }
    var progress = isLoading ? 299 : 299 - (percentage / 100) * 229;
    return !isFutureTier ? (React.createElement("circle", { className: activeCircleClass, style: { strokeDashoffset: progress }, cx: "50", cy: "50", r: "48", stroke: "url(#red)" })) : (React.createElement(React.Fragment, null));
});
export var RenderlMobileProgressCircle = function (props) {
    var data = props.data, PerkInfo = props.PerkInfo, isLoading = props.isLoading, showUnlockAnimateTier = props.showUnlockAnimateTier, controlToggle = props.controlToggle, detailsPlcc = props.detailsPlcc, plccSwitch = props.plccSwitch;
    var item = (data || {}).item;
    return (React.createElement(Grid, { item: true, className: " process-step ", xs: 12 },
        React.createElement(Grid, { className: "gauge-wrap-perk-progress" },
            React.createElement(Grid, { item: true, xs: 12 },
                React.createElement(Grid, { className: "stepSeperator" }),
                React.createElement("div", { className: "gauge_perk_progress_container" },
                    React.createElement(Grid, { className: "gauge_perk_progress" },
                        React.createElement(RenderlSvgMobileCircle, { data: data, PerkInfo: PerkInfo, stateData: PerkInfo, isLoading: isLoading, showUnlockAnimateTier: showUnlockAnimateTier }),
                        React.createElement(SpendLevel, { data: data, stateData: PerkInfo, controlToggle: controlToggle, detailsPlcc: detailsPlcc, plccSwitch: plccSwitch, showUnlockAnimateTier: showUnlockAnimateTier, isLoading: isLoading })),
                    React.createElement(Grid, { container: true },
                        React.createElement(Grid, { item: true, xs: 3 },
                            React.createElement("p", { className: "start" },
                                "$",
                                (item === null || item === void 0 ? void 0 : item.minThresholdDisplay) || 0)),
                        React.createElement(Grid, { item: true, xs: 6 }, "\u00A0"),
                        React.createElement(Grid, { item: true, xs: 3 },
                            React.createElement("p", { className: "finish" },
                                "$",
                                (item === null || item === void 0 ? void 0 : item.maxThresholdDisplay) || 0))))))));
};
